<div class="iconHeader">
  <i class="fa" [ngClass]="icon" aria-hidden="true"></i>
  <h2 [id]="category">{{ label | i18next }}</h2>
</div>
